import React from 'react'
import { useAuth } from 'context/AuthContext';
import { Button } from 'antd';

const CardTermosDeAceite = ({...props}) => {
    const {AceitarTermoAceite} = useAuth()

    const HandleAceitarTermo = async () =>{
        const sucesso = await AceitarTermoAceite(props.id)
    }

    return (
        <div className="termos-de-aceite">
            <div className="box-text">
                <span className="title">{ props.title }</span>
                <a onClick={() => props.selecionarTermo(props.id)} className="termo" style={{cursor: "pointer"}}>
                    <i className="icon icon-eye"></i>Visualizar termo completo
                </a>
            </div>
            <Button type="primary" onClick={() => HandleAceitarTermo() }>Declaro ter lido e aceito os termos</Button>
        </div>
    );
}


export default CardTermosDeAceite;